import {
  AlarmClock,
  Archive,
  Bell,
  CalendarDays,
  CircleAlert,
  Clapperboard,
  Inbox,
  Mail,
  MailOpen,
} from 'lucide-react';
import { NOTIFICATIONS_FILTER_BY_STATE, NOTIFICATIONS_FILTER_BY_TYPE } from 'vd-constants';

const FILTER_ICONS = {
  [NOTIFICATIONS_FILTER_BY_STATE.all]: Inbox,
  [NOTIFICATIONS_FILTER_BY_STATE.read]: MailOpen,
  [NOTIFICATIONS_FILTER_BY_STATE.unread]: Mail,
  [NOTIFICATIONS_FILTER_BY_STATE.archived]: Archive,
  [NOTIFICATIONS_FILTER_BY_STATE.error]: CircleAlert,
  [NOTIFICATIONS_FILTER_BY_TYPE.alarm]: Bell,
  [NOTIFICATIONS_FILTER_BY_TYPE.clip]: Clapperboard,
  [NOTIFICATIONS_FILTER_BY_TYPE.event]: CalendarDays,
};

/** Icon for a notification filter option. Falls back to a neutral alarm glyph. */
export function notificationFilterIcon(value) {
  return FILTER_ICONS[value] ?? AlarmClock;
}
